import React from "react";
import { Box, Grid, Typography, IconButton, useTheme, useMediaQuery } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PaperliveLogo from "../../Header/paperlive-new-logo.webp";
import { EXECUTIVE_PG_DEVOPS_PROGRAM } from "../../constants/AzureDevops";
import HireFromIs from "../../PopUp/HireFromIs";

export default function Footer(props) {
  const { scrollToSection } = props;
  const isBlogPage = window.location.pathname.startsWith("/blog") || 
  window.location.pathname.startsWith("/about-us") || window.location.pathname.startsWith("/refund-policy") || window.location.pathname.startsWith("/terms") || window.location.pathname.startsWith("/privacy-policy");

  const [open, setOpen] = React.useState(false);
  
  const handleOpen = () => setOpen(true);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  

  return (
    <Box
      data-footer="v2"
      sx={{
        width: "100%",
        backgroundColor: "#000",
        color: "#fff",
        py: 6,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Main Content Wrapper (80% width) */}
      <Box
        sx={{
          width: { xs: "90%", md: "80%" },
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          position: "relative",
        }}
      >
        <Grid container spacing={6} sx={{ flex: "1 1 auto" }}>
          {/* CONTACT US */}
          <Grid item xs={12} sm={6} md={2.5}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              CONTACT US
            </Typography>

            <a href="tel:+8197868030" style={{ color: "#fff", textDecoration: "none" }}>
              <Typography variant="caption">
                India: +91 8197868030
              </Typography>
            </a>
            <br />
          </Grid>

          {/* PAPERLIVE LEARNING */}
          <Grid item xs={12} sm={6} md={2.5}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              PAPERLIVE LEARNING
            </Typography>

            <React.Fragment>
                  <a href="/about-us" style={{ color: "#fff", textDecoration: "none" }}>
                    <Typography variant="caption">{"About"}</Typography>
                  </a>
                  <br />
                </React.Fragment>
                <React.Fragment >
                  <a href="/reviews" style={{ color: "#fff", textDecoration: "none" }}>
                    <Typography variant="caption">{"Reviews"}</Typography>
                  </a>
                  <br />
                </React.Fragment>
                <React.Fragment>
                    <Typography style={{ color: "#fff", textDecoration: "none", cursor: "pointer" }} variant="caption"  onClick={handleOpen}>{"Hire From Us"}</Typography>                
                  <br />
                </React.Fragment>
                <React.Fragment>
                    <Typography style={{ color: "#fff", textDecoration: "none", cursor: "pointer" }}  variant="caption"  onClick={handleOpen}>{"Become a Trainer"}</Typography>
                  <br />
                </React.Fragment>

            {!isBlogPage && <Typography
              variant="subtitle1"
              fontWeight={700}
              gutterBottom
              pt={4}
            >
              TESTIMONIALS
            </Typography>}

            {!isBlogPage && <div onClick={() => scrollToSection('youtube')} style={{ color: "#fff", textDecoration: "none", cursor: "pointer" }}>
              <Typography variant="caption">Success Stories</Typography>
            </div>}
          </Grid>

          {/* SUPPORT */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              SUPPORT
            </Typography>

            {[
              {name: "Refund Policy",link: "/refund-policy"},
              {name: "Terms & Conditions",link: "/terms"},
              {name: "Privacy Policy", link: "/privacy-policy"},
            ].map((item) => (
              <React.Fragment key={item}>
                <a
                  href={item?.link}
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  <Typography variant="caption">{item?.name}</Typography>
                </a>
                <br />
              </React.Fragment>
            ))}

            <Typography
              variant="subtitle1"
              fontWeight={700}
              gutterBottom
              pt={4}
            >
              RESOURCES
            </Typography>

              <React.Fragment>
                <a
                  href="/blog"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  <Typography variant="caption">{"Blog"}</Typography>
                </a>
                <br />
              </React.Fragment>
              <React.Fragment>
                <a
                  href="/reviews"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  <Typography variant="caption">{"Reviews"}</Typography>
                </a>
                <br />
              </React.Fragment>

          </Grid>

          {/* COURSES */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              COURSES
            </Typography>

            {[
              {name:"DevOps and Cloud with GenAI Master Program",link:"/devops-and-cloud-training-online"},
              {name: "Online DevOps Course with Multi-Cloud & Gen AI Job Ready Program",link:"/devops-training-online"},
              {name: "DevOps Certification Training",link:"/devops-certification-training"},
              {name:"AWS Certification Training",link:"/aws-solution-architect"},
              {name:"Azure Certification Training",link:"/microsoft-azure"},
              {name:"GCP Certification Training",link:"/google-cloud-platform"},
              {name: "Full Stack Web Development with GenAI", link: "/full-stack-web-development"}
            ].map((course) => (
              <React.Fragment key={course}>
                <a
                  href={course?.link}
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  <Typography variant="caption">{course?.name}</Typography>
                </a>
                <br />
              </React.Fragment>
            ))}
          </Grid>
        </Grid>

        {/* Logo */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: { xs: "80px", md: "150px" },
            height: "auto",
          }}
        >
          <img
            loading="lazy"
            src={PaperliveLogo}
            alt="Paperlive Logo"
            style={{ width: "80%", filter: "invert(1)" }}
          />
        </Box>
      </Box>

      {/* Bottom Section */}
      <Box
        sx={{
          width: { xs: "90%", md: "50%" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          mt: 6,
          borderTop: "1px solid rgba(255,255,255,0.1)",
          pt: 3,
        }}
      >
        <Box>
          <Typography variant="caption" sx={{ color: "#ccc", display: "block" }}>
            © 2025 PAPERLIVE, All rights reserved
          </Typography>
        </Box>

        <Box>
          <IconButton
            aria-label="Instagram"
            component="a"
            href="https://www.instagram.com/paperlive_learning/"
            sx={{ color: "#fff", "&:hover": { color: "#B197FC" } }}
          >
            <InstagramIcon />
          </IconButton>

          <IconButton
            aria-label="LinkedIn"
            component="a"
            href="https://www.linkedin.com/company/paperlive-learning/"
            sx={{ color: "#fff", "&:hover": { color: "#B197FC" } }}
          >
            <LinkedInIcon />
          </IconButton>

          <IconButton
            aria-label="YouTube"
            component="a"
            href="https://www.youtube.com/channel/UCmoB9HjrMnB3eZ64qzb5lBg"
            sx={{ color: "#fff", "&:hover": { color: "#B197FC" } }}
          >
            <YouTubeIcon />
          </IconButton>
        </Box>
      </Box>

      {/* Disclaimer */}
      <Box sx={{ width: { xs: "90%", md: "80%" }, mt: 4 }}>
        <Typography
          sx={{
            fontSize: "0.65rem",
            color: "#999",
            lineHeight: 1.7,
            textAlign: "left",
          }}
        >
          <b>Disclaimer:</b> PaperLive Learning offers skill-based training and professional upskilling courses only. Our programs are not postgraduate (PG) programs, diploma courses, or formal academic qualifications and do not award degrees or diplomas.
          <br /><br />
          We strive to ensure that the information and pricing displayed on our website are accurate. However, course fees, content, duration, and promotional offers may change without prior notice. Applicable pricing at the time of enrollment will be communicated clearly.
          <br /><br />
          Career outcomes depend on individual skills, effort, experience, performance, and market conditions. Placement statistics, salary figures, and success stories are for informational purposes only and do not guarantee similar results.
          <br /><br />
          References to third-party platforms, certifications, and tools are for educational purposes only and do not imply endorsement or affiliation unless explicitly stated.
        </Typography>
      </Box>
      {open &&
          <HireFromIs setOpen={setOpen} open={open} isSmallScreen={isSmallScreen} refer={false}/>
      }
    </Box>
  );
}
